import { Blockchain } from '@/constants/blockchain'
import { CURRENCY_FIELD_BACKEND_ID } from '@/constants/currency'
import Currency from '@/models-ts/Currency'
import { getCurrency } from '@/utils-ts/currencies'

export default class PrefferedCurrency extends Currency {
  static getFromSrever(props: LX.PrefferedCurrency) {
    const curr = getCurrency({ field: CURRENCY_FIELD_BACKEND_ID, value: props.currency, blockchain: props.blockchain })
    return curr ? new PrefferedCurrency(curr) : null
  }

  toServer() {
    return {
      currency: this.backendId,
      blockchain: this.blockchain,
    }
  }
}
